import React, { useState } from 'react';

const LoginForm = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [academyLogo, setAcademyLogo] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        'https://eledemgmt.site/api/admin_login.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, password }),
        }
      );
      const data = await res.json();

      if (data.success) {
        // Construimos el objeto EXACTO que tu app espera
        const user = {
          id: data.user.id,
          username: data.user.username,
          role: data.user.role,
          academy_name: data.user.academy_name,
          academy_logo: data.user.academy_logo,
          pages: data.user.pages || [],          // <-- tu array de páginas
          created_at: data.user.created_at || '' // <-- si tu API lo devuelve
        };

        // 1) Guardamos bajo la clave "currentUser"
        localStorage.setItem('currentUser', JSON.stringify(user));

        // 2) Disparamos el callback para que tu App reciba el usuario
        onLoginSuccess(user);

        // 3) Logo de academia también en estado local si quieres mostrarlo
        if (user.academy_logo) {
          setAcademyLogo(user.academy_logo);
          localStorage.setItem(
            `academyLogo_${user.id}`,
            user.academy_logo
          );
        }
      } else {
        setError(data.message || 'Credenciales inválidas');
      }
    } catch (err) {
      console.error('Error de conexión:', err);
      setError('No se pudo conectar al servidor');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        {academyLogo ? (
          <div className="mb-6 text-center">
            <img
              src={academyLogo}
              alt="Logo de la Academia"
              className="h-24 w-auto mx-auto object-contain"
            />
          </div>
        ) : (
          <h2 className="text-2xl font-bold text-center text-[#961914] mb-6">
            ELEDÉ
          </h2>
        )}

        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Usuario
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#961914]"
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#961914]"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[#961914] text-white py-2 px-4 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Iniciar Sesión
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;

